// extracted by mini-css-extract-plugin
var _1 = "cAvdP";
var _2 = "MPcwE";
var _3 = "VkCPb";
export { _1 as "ctaButtonPosition", _2 as "ctaForegroundSize", _3 as "splashAspectRatio" }
